const Colors = [
  "#E57373",
  "#81C784",
  "#64B5F6",
  "#FFD54F",
  "#FF8A65",
  "#FFD180",
  "#A1887F",
  "#4DB6AC",
  "#9575CD",
  "#FF8A80",
  "#4FC3F7",
  "#AED581",
  "#4DD0E1",
  "#FFD54F",
  "#81C784",
  "#64B5F6",
  "#E57373",
  "#64B5F6",
  "#81C784",
  "#FFD54F",
  "#FF8A65",
  "#FFD180",
  "#A1887F",
  "#4DB6AC",
  "#9575CD",
  "#FF8A80",
  "#4FC3F7",
  "#AED581",
  "#4DD0E1",
  "#FFD54F",
  "#81C784",
  "#64B5F6",
  "#E57373",
  "#64B5F6",
  "#81C784",
  "#FFD54F",
  "#FF8A65",
  "#FFD180",
  "#A1887F",
  "#4DB6AC",
  "#9575CD",
  "#FF8A80",
  "#4FC3F7",
  "#AED581",
  "#4DD0E1",
  "#FFD54F",
  "#81C784",
  "#64B5F6",
];

export default Colors;
